module.exports = __webpack_public_path__ + "static/media/016.40681a0d.jpg";